/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://4rwb3ihcwrgdfmu5mtygmtqj7m.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-b6eojcsgszfppgp6sh2eewvxey",
    "aws_cloud_logic_custom": [
        {
            "name": "lrexsiterest",
            "endpoint": "https://rmz3y3a64d.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:1934f732-6f48-4dcc-a744-a57008cfba06",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_SehUTLeFk",
    "aws_user_pools_web_client_id": "4cludc8fa704evpkvjsohtu90",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "lrexsite-bucket155400-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
